import serviceRequest from "utils/request";

const baseUrl = "/api/software";

export const getSoftwareRequests = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-software-requests`,
		method: "get",
		params,
	});
};

export const getSoftwareRequestsRes = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-software-requests-res`,
		method: "get",
		params,
	});
};

export const getSoftwareDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/detail`,
		method: "get",
		params,
	});
};

export const softwareSubmit = (param) => {
	return serviceRequest({
		url: `${baseUrl}/submit`,
		method: "post",
		data: param,
	});
};

export const softwareEdit = (param) => {
	return serviceRequest({
		url: `${baseUrl}/edit`,
		method: "post",
		data: param,
	});
};
